<template>
  <div>
    <v-navigation-drawer v-model="drawer" app color="#222d32" class="notPrint">
      <v-list dense>
        <v-list-item v-for="linkItem in sidebarLinkItens" :key="linkItem.text" :to="linkItem.link">
          <v-list-item-action>
            <v-icon color="#fff">{{ linkItem.icon }}</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title class="title-menu text-wrap" style="min-width: 160px;">
              {{ linkItem.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="#3cbc62" dark class="notPrint">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>SIGU</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu v-model="menu" bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark icon v-bind="attrs" v-on="on">
            <v-badge :content="newChamado.length" :value="newChamado.length" color="red" overlap>
              <v-icon>mdi-bell</v-icon>
            </v-badge>
          </v-btn>
        </template>

        <v-row v-for="(item, i) in newChamado" :key="i">
          <v-card aria-selected="true" class="v-list-item" role="listitem" tabindex="0" @click="routerNotification(item.linkRouterNotification)">
            <v-icon>{{ item.icon }}</v-icon>
            <v-card-text>{{ item.textCard }}</v-card-text>
          </v-card>
        </v-row>
      </v-menu>

      <v-chip class="ma-2" color="fff" outlined pill>
        {{ $store.getters.nome }}
      </v-chip>

      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark icon v-bind="attrs" v-on="on">
            <button>Conf</button>
          </v-btn>
        </template>
        <v-list>
          <div class="v-list-item-group" role="listbox">
            <div aria-disabled="true" aria-selected="true" class="v-list-item" role="listitem" tabindex="-1" @click="showProfile">
              Perfil
            </div>
            <div aria-disabled="true" aria-selected="true" class="v-list-item" role="listitem" tabindex="-1" @click="logout">
              Sair
            </div>
          </div>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <slot></slot>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  watch: {
    menu() {
      if (this.newChamado.length > 0) {
        if (!this.menu) {
          this.newChamado = [];
          this.statusNotify = false;
        } else {
          this.statusNotify = true;
        }
      }
    },

    newChamado() {
      if (this.newChamado) {
        this.statusNotify = false;
      } else {
        this.statusNotify = true;
      }
    },
  },

  props: {
    source: String,
  },
  computed: {
    ...mapState({
      currentUser: "currentUser",
    }),
  },
  data: () => ({
    menu: null,
    newChamado: [],
    dialog: false,
    drawer: null,
    statusNotify: true,
    sidebarLinkItens: [
      {
        icon: "mdi-monitor-dashboard",
        text: "Dashboard",
        link: "/",
      },
      {
        icon: "mdi-account-group",
        text: "Funcionários",
        link: "/funcionario",
      },
      {
        icon: "mdi-google-maps",
        text: "Endereços",
        link: "/enderecoOrdemServico",
      },
      {
        icon: "mdi-table-cog",
        text: "Configuração Pedidos",
        link: "/configuracaopedidos",
      },
      {
        icon: "mdi-file-table",
        text: "Produtos no Sistema",
        link: "/produtosSistema",
      },
      {
        icon: "mdi-square-edit-outline",
        text: "Produtos em Estoques",
        link: "/produtos",
      },
      {
        icon: "mdi-archive",
        text: "Notas",
        link: "/historicoEntrada",
      },
      {
        icon: "mdi-server",
        text: "Dispensas",
        link: "/dispensa",
      },
      {
        icon: "mdi-book",
        text: "Whitelists",
        link: "/whitelist",
      },
      {
        icon: "mdi-format-list-checks",
        text: "Solicitações de Produtos",
        link: "/solicitacoesDeProdutos",
      },
      {
        icon: "mdi-archive-arrow-up",
        text: "Dispensas de Setores",
        link: "/dispensasDeSetores",
      },
      {
        icon: "mdi-briefcase-account-outline",
        text: "Dispensas de Pacientes",
        link: "/dispensaPacientes",
      },
      {
        icon: "mdi-file-chart-outline",
        text: "Relatorio de Solicitação",
        link: "/relatorioSolicitacoesProdutos",
      },
      {
        icon: "mdi-clipboard-outline",
        text: "Relatório de Custo",
        link: "/relatorioMovimentacao",
      },
      {
        icon: "mdi-calendar-clock",
        text: "Relatório de Alterações Estoque",
        link: "/relatorioalteracoes",
      },
      {
        icon: "mdi-file-clock",
        text: "Relatório de Entradas Nota",
        link: "/relatorioentradas",
      },
      {
        icon: "mdi-chart-bar",
        text: "Relatório de Movimentações Mensais",
        link: "/relatorioSaidaMensalAdm",
      },
      {
        icon: "mdi-clipboard-text-clock",
        text: "Relatório Dispensas Teste Rápido",
        link: "/relatoriodispensakits",
      },
      {
        icon: "mdi-numeric-1-box-multiple-outline",
        text: "Importar Nota",
        link: "/importarNotaAdm",
      },
    ],
  }),
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    },
    showProfile() {
      this.$router.push("/perfil");
    },
    routerNotification(linkRouterNotification) {
      this.$router.push(linkRouterNotification);
    },
  },
};
</script>

<style scoped>
.title-menu {
  color: #fff;
}
.print {
  display: none;
}
@media print {
  .notPrint {
    display: none;
  }
  .print {
    display: block;
  }
}
</style>
